module.exports = __webpack_public_path__ + "static/media/me_wedding_mobile.5324ece3.jpg";